module.exports = __webpack_public_path__ + "media/images/lb/586-7ffbe0f7e80aecad285ff71a718a9e80.svg";